var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 14.2C15.6455 14.2 18.6004 11.2451 18.6004 7.6C18.6004 3.95492 15.6455 1 12.0004 1C8.35531 1 5.40039 3.95492 5.40039 7.6C5.40039 11.2451 8.35531 14.2 12.0004 14.2Z",
    stroke: "#322D60",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.4583C1 19.8483 5.95 14.7554 12 14.7554C18.05 14.7554 23 19.8538 23 25.4583V26.3054H1V25.4583Z",
    stroke: "#322D60",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOverview);
export default __webpack_public_path__ + "static/media/PersonOverview.9a6cc6e542cb6ba7f06ae48c56966aaa.svg";
export { ForwardRef as ReactComponent };